"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreOptions = void 0;
/**
 * @property {boolean}  showWhenClassDone        - Automatically release scores, questions and answers to students after scoring of class set is complete
 * @property {boolean}  showWhenClassSubmitted   - Automatically release scores, questions and answers to students after all students submission
 * @property {boolean}  showWhenStudentSubmitted - Automatically release scores, questions and answers to students after individual student submission
 */
var ScoreOptions = /** @class */ (function () {
    function ScoreOptions(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    return ScoreOptions;
}());
exports.ScoreOptions = ScoreOptions;
